// Rules
import {extend} from 'vee-validate';
import {required, min, max, required_if, email, integer, confirmed} from 'vee-validate/dist/rules';


extend("date", {
  validate: value =>
    /^(19|20)\d\d[/]([1-9]|0[1-9]|1[012])[/]([1-9]|0[1-9]|[12][0-9]|3[01])$/.test(
      value
    ),
  message: "La date doit être au format YYYY/MM/DD"
});
extend('confirmed', {
  ...confirmed,
  // message: 'The two {_field_} fields must be same'
});
extend('email', {
  ...email,
  message: 'Ce champ doit être une adresse mail'
});
extend('required', {
  ...required,
  message: 'Ce champ est requis'//'The field {_field_} is required'
});
extend('min', {
  params: ['length'],
  ...min,
  message: 'Ce champ doit contenir au moins {length} caractères'
});
extend('max', {
  params: ['length'],
  ...max,
  message: 'Ce champ doit contenir au plus {length} caractères'
});
extend('regex', {
  ...integer,
  message: 'The field {_field_} does not match requested value'
});
extend('integer', {
  ...integer,
  message: 'Ce champ doit être un entier'
});
extend('required_if', {
  ...required_if,
  message: 'Ce champ est requis'
});
